import React from 'react';
import { timeAgo } from '@/utils/ts/stringUtils';
import { SATHI_APP_URL } from '@/utils/constants/sathi';

import RightArrow from '@/components/Icons/icons/RightArrow';
import ButtonComponent from '../../ButtonComponent/ButtonComponent';

export default function SathiMigrationCompletedNotification({
  notification,
  setShowNotificationDropdown,
  markSingleNotificationAsSeen,
}) {
  const migratedCount =
    notification?.content?.migratedCount ?? notification?.content?.influencerCount ?? notification?.content?.count ?? 0;

  const handleAction = () => {
    markSingleNotificationAsSeen();
    setShowNotificationDropdown(null);
    window.open(SATHI_APP_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div">🎉</div>
      <div className="text-div" style={{ marginLeft: 6 }}>
        <h3 className="title">Migration complete!</h3>
        <p className="description">
          We have successfully migrated {migratedCount} Influencers. The affiliate links and discount codes remain the
          same
        </p>
        <div className="mt-2">
          <ButtonComponent
            variant="text-highlight"
            style={{ padding: '0px' }}
            textStyle={{ fontSize: '14px' }}
            onClick={handleAction}
            rightIcon={<RightArrow color="var(--text-highlight)" />}>
            Go to SATHI
          </ButtonComponent>
        </div>
        <p className="timestamp" style={{ paddingTop: 8 }}>
          {timeAgo(notification?.createdAt)}
        </p>
      </div>
    </div>
  );
}
